var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useContext, useEffect } from "react";
import { BreadcrumbContext } from "../../../../components/Breadcrumb";
import { AuthContext } from "../../../../components/FirebaseAuth";
import { FirebaseAuth } from "../../../../components/FirebaseAuth/firebase";
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import { Link } from "react-router-dom";
import Loader from "../../../../components/Loader";
import Plot from 'react-plotly.js';
import Placeholder from 'react-bootstrap/Placeholder';
import { Alert } from "react-bootstrap";
import AccountSteps from "../../../../components/AccountSteps";
var Overview = function () {
    var _a;
    var title = "Overview";
    var userData = useContext(AuthContext).userData;
    var setBreadcrumb = useContext(BreadcrumbContext).setBreadcrumb;
    var _b = useState(null), settingsComplete = _b[0], setSettingsComplete = _b[1];
    var _c = useState(false), deployNeeded = _c[0], setDeployNeeded = _c[1];
    var _d = useState(null), numRegistrations = _d[0], setNumRegistrations = _d[1];
    var _e = useState(null), monthlyLaunchesPerformed = _e[0], setMonthlyLaunchesPerformed = _e[1];
    var _f = useState(null), monthlyActiveUsers = _f[0], setMonthlyActiveUsers = _f[1];
    var _g = useState(null), estimatedCost = _g[0], setEstimatedCost = _g[1];
    var _h = useState([]), regions = _h[0], setRegions = _h[1];
    var _j = useState([]), statusMessages = _j[0], setStatusMessages = _j[1];
    var _k = useState({ mau: [], mlp: [], time: [] }), stats = _k[0], setStats = _k[1];
    var _l = useState(null), billingRenewDate = _l[0], setBillingRenewDate = _l[1];
    var _m = useState(null), billingRenewDateOld = _m[0], setBillingRenewDateOld = _m[1];
    var fetchSettings = function (accountId) { return __awaiter(void 0, void 0, void 0, function () {
        var doc, api_settings, docs, account_settings, getApiMetrics, res, stats_1, mau_1, mlp_1, time_1, mau_diffs, mlp_diffs, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, FirebaseAuth.firestore().collection("subdomains").doc(accountId).get()];
                case 1:
                    doc = _a.sent();
                    if (!doc.exists) return [3 /*break*/, 9];
                    api_settings = doc.data();
                    if (!(api_settings !== undefined && api_settings.hasOwnProperty("subdomainName"))) return [3 /*break*/, 7];
                    // subdomain exists
                    setSettingsComplete(true);
                    return [4 /*yield*/, FirebaseAuth.firestore().collection("accounts").doc(accountId).collection("api_settings").doc("private").get()];
                case 2:
                    docs = _a.sent();
                    if (!docs.exists) return [3 /*break*/, 6];
                    account_settings = docs.data();
                    // get deployment status
                    if (account_settings !== undefined && account_settings.hasOwnProperty("lastSave")) {
                        if (account_settings.hasOwnProperty("lastDeploy")) {
                            if (account_settings.lastSave.toDate() > account_settings.lastDeploy.toDate()) {
                                setDeployNeeded(true);
                            }
                            else {
                                setDeployNeeded(false);
                            }
                        }
                        else {
                            setDeployNeeded(true);
                        }
                    }
                    getApiMetrics = CloudFunctions.httpsCallable('oncall');
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, getApiMetrics({
                            name: "getApiMetrics",
                            data: {
                                accountId: userData.currentAccount.id
                            }
                        })];
                case 4:
                    res = _a.sent();
                    //TODO: add this data back in to response
                    if ('registeredPlatforms' in res.data) {
                        setNumRegistrations(res.data.registeredPlatforms);
                    }
                    else if ('registeredTools' in res.data) {
                        setNumRegistrations(res.data.registeredTools);
                    }
                    if ('price' in res.data) {
                        setEstimatedCost(res.data.price / 100);
                    }
                    else {
                        setEstimatedCost(0);
                    }
                    if ('status' in res.data) {
                        //console.log(res.data)
                        setStatusMessages(res.data.status.messages || []);
                        setRegions(res.data.status.regions);
                    }
                    else {
                        setRegions([{
                                "healthy": true,
                                "name": "Self Hosted"
                            }]);
                    }
                    if ('stats' in res.data) {
                        stats_1 = res.data.stats;
                        stats_1.sort(function (a, b) { return a.time - b.time; });
                        mau_1 = [];
                        mlp_1 = [];
                        time_1 = [];
                        stats_1.forEach(function (e) {
                            mau_1.push(e.mau);
                            mlp_1.push(e.mlp);
                            time_1.push(e.time);
                        });
                        mau_diffs = mau_1.slice(1).map(function (x, i) { return x >= mau_1[i] ? x - mau_1[i] : x; });
                        mlp_diffs = mlp_1.slice(1).map(function (x, i) { return x >= mlp_1[i] ? x - mlp_1[i] : x; });
                        setStats({
                            mau: mau_diffs,
                            mlp: mlp_diffs,
                            time: time_1.splice(1)
                        });
                        if ((stats_1 === null || stats_1 === void 0 ? void 0 : stats_1.length) > 0) {
                            setMonthlyActiveUsers(parseInt(stats_1[stats_1.length - 1].mau.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")));
                            setMonthlyLaunchesPerformed(parseInt(stats_1[stats_1.length - 1].mlp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")));
                        }
                    }
                    if ('monthlyActiveUsers' in res.data) {
                        setMonthlyActiveUsers(res.data.monthlyActiveUsers);
                    }
                    else {
                        setMonthlyActiveUsers(0);
                    }
                    if ('monthlyActiveUsers' in res.data) {
                        setMonthlyLaunchesPerformed(res.data.monthlyLaunchesPerformed);
                    }
                    else {
                        setMonthlyLaunchesPerformed(0);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 8];
                case 7:
                    setSettingsComplete(false);
                    _a.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    setSettingsComplete(false);
                    _a.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchSettings(userData.currentAccount.id);
        var periodEnd = new Date(0);
        periodEnd.setUTCSeconds(userData.currentAccount.subscriptionCurrentPeriodEnd);
        periodEnd.setMonth(periodEnd.getMonth() - 1);
        setBillingRenewDate(periodEnd.getTime());
        periodEnd.setMonth(periodEnd.getMonth() - 1);
        setBillingRenewDateOld(periodEnd.getTime());
    }, [userData]);
    useEffect(function () {
        setBreadcrumb([
            {
                to: "/",
                text: "Home",
                active: false,
            },
            {
                to: "/account/" + userData.currentAccount.id + "/",
                text: userData.currentAccount.name + " (".concat(userData.currentAccount.id, ")"),
                active: false,
            },
            {
                to: null,
                text: title,
                active: true,
            },
        ]);
    }, [userData, setBreadcrumb, title]);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "container-fluid", children: [_jsxs("div", { className: "animated fadeIn", children: [userData.currentAccount.subscriptionStatus && settingsComplete && statusMessages.length > 0 && (statusMessages.map(function (value, index) {
                            if (value.active) {
                                return _jsx(Alert, { variant: value.severity, children: value.message }, index);
                            }
                            return _jsx(_Fragment, {});
                        })), _jsx(AccountSteps, { accountSettingsComplete: settingsComplete || false, subscriptionStatus: userData.currentAccount.subscriptionStatus, numRegistrations: numRegistrations, onAPISettingsPage: false, onRegistrationsPage: false, hidden: settingsComplete === null || (settingsComplete === true && numRegistrations === null) || (stats.mlp.reduceRight(function (a, b) { return a + b; }, 0) > 0) || (monthlyActiveUsers !== null && monthlyActiveUsers > 0) }), userData.currentAccount.subscriptionStatus && deployNeeded && userData.currentAccount.role === 'admin' && (_jsxs("div", { className: "card border-danger mb-3", children: [_jsx("div", { className: "card-header", children: "Deploy Needed" }), _jsx("div", { className: "card-body", children: _jsxs("p", { children: ["Your API settings have been saved, but they have not been deployed. Please go to the \u00A0", _jsx(Link, { to: "/account/" + userData.currentAccount.id + "/settings", children: "API Settings" }), "\u00A0 page to deploy them."] }) })] })), !userData.currentAccount.subscriptionStatus && (_jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: "Account not active" }), _jsx("div", { className: "card-body", children: _jsxs("p", { children: ["Account status is not active,", " ", _jsx("b", { children: _jsx(Link, { to: "/account/" + userData.currentAccount.id + "/plan", children: "activate a plan here to continue" }) }), "."] }) })] }))] }), _jsxs("div", { className: "row row-cols-auto d-flex", children: [userData.currentAccount.subscriptionStatus && settingsComplete && (_jsx("div", { className: "col d-flex", style: { minWidth: 250 + "px" }, children: _jsx("div", { className: "card text-white", style: { flexGrow: 1, backgroundColor: "#013f71" }, children: _jsxs("div", { className: "card-body", children: [_jsx("h5", { className: "card-title", children: "Registrations" }), _jsx("h6", { className: "card-subtitle mb-2 text-muted", children: " " }), _jsx("h1", { className: "card-text", children: _jsx(Link, { to: "/account/" + userData.currentAccount.id + "/registrations", className: "col d-flex text-white", style: { minWidth: 50 + "px" }, children: numRegistrations === null ? _jsx(Loader, {}) : numRegistrations }) })] }) }) })), userData.currentAccount.subscriptionStatus && settingsComplete && (_jsx("div", { className: "col d-flex", style: { minWidth: 250 + "px" }, children: _jsx("div", { className: "card text-white", style: { flexGrow: 1, backgroundColor: "#013f71" }, children: _jsxs("div", { className: "card-body", children: [_jsx("h5", { className: "card-title", children: "Total Launches This Month" }), _jsx("h6", { className: "card-subtitle mb-2 text-muted", children: " " }), _jsx("h1", { className: "card-text", children: monthlyLaunchesPerformed !== null ? monthlyLaunchesPerformed : _jsx(Loader, { size: "1x", text: "" }) })] }) }) })), userData.currentAccount.subscriptionStatus && settingsComplete && (_jsx("div", { className: "col d-flex", style: { minWidth: 250 + "px" }, children: _jsx("div", { className: "card text-white", style: { flexGrow: 1, backgroundColor: "#013f71" }, children: _jsxs("div", { className: "card-body", children: [_jsx("h5", { className: "card-title", children: "Monthly Active Users" }), _jsx("h6", { className: "card-subtitle mb-2 text-muted", children: " " }), _jsx("h1", { className: "card-text", children: monthlyActiveUsers !== null ? monthlyActiveUsers : _jsx(Loader, { size: "1x", text: "" }) })] }) }) })), userData.currentAccount.subscriptionStatus && settingsComplete && (_jsx("div", { className: "col d-flex", style: { minWidth: 250 + "px" }, children: _jsx("div", { className: "card text-white", style: { flexGrow: 1, backgroundColor: "#013f71" }, children: _jsxs("div", { className: "card-body", children: [_jsxs("h5", { className: "card-title", children: ["Next Bill: ", (new Date(userData.currentAccount.subscriptionCurrentPeriodEnd * 1000)).toLocaleDateString()] }), _jsx("h6", { className: "card-subtitle mb-2 text-muted", children: " " }), _jsx("h1", { className: "card-text", children: estimatedCost !== null ? "$" + estimatedCost : _jsx(Loader, { size: "1x", text: "" }) })] }) }) })), userData.currentAccount.subscriptionStatus && settingsComplete && (_jsx("div", { className: "col d-flex", style: { maxWidth: 200 + "px", minWidth: 200 + "px" }, children: _jsxs("div", { className: "card", style: { flexGrow: 1 }, children: [_jsx("div", { className: "card-header", children: "API Service Health" }), _jsx("div", { className: "card-body", children: (regions === null || regions === void 0 ? void 0 : regions.length) > 0 ?
                                            regions.map(function (r, i) {
                                                return _jsxs("div", { children: [_jsx("i", { className: r.healthy ? "fa fa-check text-success" : "fa fa-exclamation-triangle text-warning" }), " ", r.name] }, i);
                                            }) :
                                            _jsx(Loader, { size: "2x", text: "" }) })] }) })), userData.currentAccount.subscriptionStatus && settingsComplete && ((_a = userData.currentAccount.features) === null || _a === void 0 ? void 0 : _a.trial) && monthlyLaunchesPerformed !== null && (_jsx("div", { className: "col d-flex", style: { minWidth: 200 + "px" }, children: _jsxs("div", { className: "card border-warning", style: { flexGrow: 1 }, children: [_jsx("div", { className: "card-header", children: "Trial Status" }), _jsxs("div", { className: "card-body", children: [_jsx("h6", { className: "card-subtitle mb-2 text-muted", children: " " }), _jsxs("h4", { className: "card-text", children: ["You have ", _jsx("b", { children: 500 - monthlyLaunchesPerformed }), " launches left this month."] }), _jsx("a", { className: "btn btn-success", href: '/account/' + userData.currentAccount.id + '/billing/plan', children: "Upgrade Now" })] })] }) })), _jsx("div", { className: "w-100" }), userData.currentAccount.subscriptionStatus && settingsComplete && (_jsxs(_Fragment, { children: [_jsx("div", { className: "col d-flex", children: _jsx("div", { className: "card", style: { flexGrow: 1 }, children: _jsx("div", { className: "card-body p-1", children: stats.time ?
                                                _jsx(Plot, { data: [
                                                        {
                                                            x: stats.time,
                                                            y: stats.mlp,
                                                            type: 'scatter',
                                                            mode: 'lines',
                                                            marker: { color: '#023E73' },
                                                            name: 'Launches Performed'
                                                        },
                                                        {
                                                            x: stats.time,
                                                            y: stats.mau,
                                                            type: 'scatter',
                                                            mode: 'lines',
                                                            marker: { color: '#BF0436' },
                                                            name: 'New Users'
                                                        },
                                                    ], layout: {
                                                        title: 'Hourly Usage Statistics',
                                                        showlegend: true,
                                                        legend: {
                                                            borderwidth: 0,
                                                            x: 1,
                                                            xanchor: 'right',
                                                            y: 1.1,
                                                            orientation: 'h'
                                                        },
                                                        images: [{
                                                                source: "/logo_large.png",
                                                                xref: "paper",
                                                                yref: "paper",
                                                                x: 0.05,
                                                                y: 0.9,
                                                                sizex: 0.3,
                                                                sizey: 0.3,
                                                                opacity: 0.1,
                                                                layer: "below"
                                                            }],
                                                        annotations: [
                                                            {
                                                                x: billingRenewDate || 0,
                                                                y: 1,
                                                                xref: 'x',
                                                                yref: 'y',
                                                                text: 'Billing Restart',
                                                                showarrow: true,
                                                                arrowhead: 0,
                                                                opacity: 0.5,
                                                                ax: 0,
                                                                ay: -220
                                                            },
                                                            {
                                                                x: billingRenewDateOld || 0,
                                                                y: 1,
                                                                xref: 'x',
                                                                yref: 'y',
                                                                text: 'Previous Billing Cycle',
                                                                showarrow: true,
                                                                arrowhead: 0,
                                                                opacity: 0.5,
                                                                ax: 0,
                                                                ay: -220
                                                            }
                                                        ],
                                                        xaxis: {
                                                            autorange: true,
                                                            rangeselector: { buttons: [
                                                                    {
                                                                        count: 1,
                                                                        label: '1d',
                                                                        step: 'day',
                                                                        stepmode: 'backward'
                                                                    },
                                                                    {
                                                                        count: 7,
                                                                        label: '7d',
                                                                        step: 'day',
                                                                        stepmode: 'backward'
                                                                    },
                                                                    {
                                                                        count: 1,
                                                                        label: '1m',
                                                                        step: 'month',
                                                                        stepmode: 'backward'
                                                                    },
                                                                    { step: 'all' }
                                                                ] },
                                                            /* @ts-ignore */
                                                            rangeslider: { autorange: true },
                                                            type: 'date'
                                                        },
                                                        yaxis: {
                                                            autorange: true,
                                                            type: 'linear'
                                                        },
                                                        margin: {
                                                            b: 10,
                                                            l: 60,
                                                            r: 10,
                                                            t: 60
                                                        }
                                                    }, useResizeHandler: true, style: { width: "100%", height: "450px" } })
                                                :
                                                    _jsx(Placeholder, { animation: "glow", style: { width: "100%", height: 450 } }) }) }) }), _jsx("div", { className: "w-100", children: _jsx(Alert, { variant: "info", className: "ml-3 mr-3", children: "NOTE: Some statistics are not real-time and may be delayed by up to 30 minutes." }) })] }))] })] }) }));
};
export default Overview;
